import window from "common/objects/window";

/**
 * This is a helper class that can detect when certain breakpoints are met.
 *
 * These breakpoints match exactly the ones defined by breakpoints.less.
 *
 * If at all possible, use CSS for responsive behavior.  This should be a class of last resort.
 */
const Breakpoints = kendo.data.ObservableObject.extend({

    desktop: false,
    smallDesktop: false,
    phone: false,

    init: function() {
        kendo.data.ObservableObject.fn.init.apply(this, arguments);
        var DESKTOP = window.matchMedia(Breakpoints.DESKTOP_QUERY);
        var SMALL_DESKTOP = window.matchMedia(Breakpoints.SMALL_DESKTOP_QUERY);
        var PHONE = window.matchMedia(Breakpoints.PHONE_QUERY);
        var me = this;
        var update = function() {
            me.set("desktop", DESKTOP.matches);
            me.set("smallDesktop", SMALL_DESKTOP.matches);
            me.set("phone", PHONE.matches);
        };
        update();
        DESKTOP.addListener(update);
        SMALL_DESKTOP.addListener(update);
        PHONE.addListener(update);

        this.destroy = function() {
            DESKTOP.removeListener(update);
            SMALL_DESKTOP.removeListener(update);
            PHONE.removeListener(update);
        };
    }
});

Breakpoints.DESKTOP_QUERY = "only screen and (min-width: 631px) and (min-height: 451px)";
Breakpoints.SMALL_DESKTOP_QUERY = "only screen and (max-width: 630px) and (min-width: 521px) and (min-height: 451px)";
Breakpoints.PHONE_QUERY = "only screen and (max-width: 520px), only screen and (max-height: 450px)";
Breakpoints.NOT_PHONE_QUERY = "only screen and (min-width: 521px) and (min-height: 451px)";

export default Breakpoints;
